import {
	Menu,
	MenuGroup,
	MenuGroupHeader,
	MenuList,
	MenuPopover,
	MenuTrigger,
	mergeClasses,
} from "@fluentui/react-components";
import { MenuListProps } from "./types";
import { useStyle } from "./style";
import { Flex } from "../flex";

export const MenuListPopover = (props: MenuListProps) => {
	const classes = useStyle();

	return (
		<Flex style={{ minWidth: 0 }} className={props.classesName?.container}>
			<Menu
				inline
				closeOnScroll={props.closeOnScroll}
				openOnHover={props.openOnHover}
				positioning={props.positioning}
				checkedValues={props.checkedValues}
				defaultCheckedValues={props.defaultCheckedValues}
				onCheckedValueChange={props.onCheckedValueChange}
				persistOnItemClick={props.persistOnItemClick}
				open={props.open ?? undefined}
				onOpenChange={props.onOpenChange}
			>
				<MenuTrigger disableButtonEnhancement children={props.trigger} />
				<MenuPopover
					className={mergeClasses(
						classes.content,
						props.classesName?.menuPopover,
						props.classesName?.menuPopoverOutbound
					)}
				>
					<MenuGroup>
						{props.itemsHeader && (
							<MenuGroupHeader className={props.classesName?.menuHeader}>
								{props.itemsHeader}
							</MenuGroupHeader>
						)}
						{props.itemsDivider && props.itemsDivider}
						<MenuList className={props.classesName?.menuList}>
							{props.items}
						</MenuList>
					</MenuGroup>
				</MenuPopover>
			</Menu>
		</Flex>
	);
};
